import { render } from "./Reimbursements.vue?vue&type=template&id=a4b632b0&ts=true"
import script from "./Reimbursements.vue?vue&type=script&lang=ts"
export * from "./Reimbursements.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__